import React, { useEffect } from 'react';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useOrganization } from 'Shared/utils/hooks/use-organization';
import { usePartnerInfo } from 'Shared/utils/hooks/use-partner-info';

type Props = {
  children: React.ReactNode;
};

const PendoProvider = ({ children }: Props) => {
  const { user, isThirdPartyUser, isOrgAdmin, isPiUser, isManager } = useCurrentUser();
  const { organization } = useOrganization();
  const { partnerInfo } = usePartnerInfo();

  useEffect(() => {
    if (window.pendo?.identify && user && organization && partnerInfo) {
      pendo.identify({
        visitor: {
          id: user.piUserGuid,
          performId: user.slug,
          email: user.email,
          firstName: user.first_name,
          lastName: user.last_name,
          fullName: user.full_name,
          performRole: user.role,
          browserHeight: window.innerHeight,
          browserWidth: window.innerWidth,
          browserResolution: `${window.innerWidth} x ${window.innerHeight}`,
          loggedInCompanyId: organization.piCompanyGuid,
          isLoggedIntoDefaultCompany: !isThirdPartyUser,
          isThirdPartyUser: isThirdPartyUser,
          isPerformOrganizationAdmin: isOrgAdmin,
          isPerformManager: isManager,
          isPiUser: isPiUser,
          partnerContactEmail: partnerInfo.forcePartnerContactEmail,
          partnerContactFullName: partnerInfo.forcePartnerContactName,
        },
        account: {
          id: organization.piCompanyGuid,
          name: organization.name,
          isPerformDirectClient: partnerInfo.forcePartnerIsDirect,
        },
      });
    }
  }, []);

  return <>{children}</>;
};

export default PendoProvider;
